// Projects with a `tagline` and `period` are the ones on the CV; they are shown as featured cards.
export const projects = [
    {
        title: "Ranga",
        tagline: "AI Powered Lost and Found Platform for Rwanda",
        period: "05/2026 – 08/2026",
        description: "Built Ranga, an AI-powered lost-and-found platform for Rwanda that helps people recover lost belongings and important documents before seeking replacements through services like Irembo. Implemented intelligent matching, OCR, sensitive-data blurring, identity verification, and secure rewards.",
        stack: ["Next.js", "Tailwind CSS", "PostgreSQL", "Prisma"],
        githubLink: "https://github.com/Paulin-NIYOBYOSE",
        liveLink: "https://ranga.app/",
        image: "/ranga.png"
    },
    {
        title: "Zero QS",
        tagline: "AI-Augmented Quantity Surveying Platform for Africa",
        period: "09/01/2026 – 12/08/2026",
        description: "Built Zero QS, an AI-augmented quantity surveying platform designed for African construction professionals. The platform helps quantity surveyors build Bills of Quantity (BOQ) and Bills of Materials (BOM) automatically using AI and results are automatically sent to take off project specific.",
        stack: ["Next.js", "Tailwind CSS", "AI/ML"],
        githubLink: "https://github.com/Paulin-NIYOBYOSE",
        liveLink: "https://zeroqs.vercel.app/",
        image: "/zero.png"
    },
    {
        title: "Digital Cost estimation",
        description: "A digital platform for estimating construction costs, planning construction projects, managing employees and companies",
        stack: ["Next.js", "Tailwind CSS", "NestJs", "PostgresQL", "Prisma"],
        githubLink: "https://github.com/Paulin-NIYOBYOSE",
        liveLink: "https://www.dsestimation.rw/",
        image: "/dsestimation.png"
    },
    {
        title: "Smart evaluation",
        description: "A web application for creating smart evaluation reports, enabling users to structure content into chapters and sections, insert charts and assets, collaborate, and export professional documents in PDF and Word formats.",
        stack: ["React Native", "NativeWind"],
        githubLink: "https://github.com/Paulin-NIYOBYOSE",
        liveLink: "https://reportflowv2.vercel.app/",
        image: "/smart.png"
    },
    {
        title: "Akarongo Fashion",
        description: "A mobile application built with React Native for selling clothes online. It provides users with a clean interface to browse products, view details, add items to cart, and place orders",
        stack: ["React Native", "NativeWind"],
        githubLink: "https://github.com/Paulin-NIYOBYOSE/akarongo-fashion",
        liveLink: "https://github.com/Paulin-NIYOBYOSE/akarongo-fashion",
        image: "/akarongo.png"
    },
    {
        title: "IS Technology",
        description: "An online tech hub for selling all electronic devices with inventory management and payment integration",
        stack: ["React", "Tailwind", "Java"],
        githubLink: "https://github.com/Paulin-NIYOBYOSE/Is-Tech",
        liveLink: "https://is-tech-eta.vercel.app/",
        image: "/istech.png"
    },
    {
        title: "Cineflix",
        description: "A Next-Gen Netflix Clone with Enhanced Features including user authentication and movie recommendations",
        stack: ["React", "Tailwind CSS"],
        githubLink: "https://github.com/Paulin-NIYOBYOSE/Cineflix",
        liveLink: "https://cineflix0-movies.vercel.app/",
        image: "/cineflix.png"
    },
];
